import { Component, inject, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-modal-desired-smart',
  templateUrl: './modal-desired-smart.component.html',
  styleUrls: ['./modal-desired-smart.component.css']
})
export class ModalDesiredSmartComponent {
  public readonly _utilityService: UtilityService = inject(UtilityService);
  private readonly _modalRef: NzModalRef = inject(NzModalRef);

  @Input() user: any;
  @Input() desiredSmart: number;

  msgModalDesiredSmart: string = '';

  ngOnInit() {
    this.msgModalDesiredSmart = `Secondo il tuo contratto, hai diritto a un massimo di <b>${this.user.maxSmart} giorni</b> di smart working a settimana. `;
  }

  closeModal() {
    this._modalRef.close(null);
  }

  save() {
    this._modalRef.close(this.desiredSmart);
  }
}
